import type { AppConfigState } from '~/core/entities/AppConfig';
import type { ProductCategories } from '~/core/entities/strapi/Category';
import { AppService } from '~/services/App/Index';

export const useAppStore = defineStore('app', {
  state: (): AppConfigState => ({
    isInitialized: false,
    openHeaderDropdown: false,

    productCategories: [],
  }),
  actions: {
    initialize() {
      this.$patch(AppService.initialize());
    },

    setOpenHeaderDropdown(value: boolean) {
      this.openHeaderDropdown = value;
    },

    setProductCategories(categories: ProductCategories[]) {
      this.productCategories = categories;
    },
  },
});
